import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { ButtonOutlined, Flex, SvgIcon, Text } from 'Components/Base';

const BannerWrapper = styled(Flex)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'unset',
  position: 'relative',
  color: 'white',
  overflow: 'hidden',
  width: '100%',
  borderRadius: `${theme.radii[3]}px`,
  padding: `${theme.space[6]}px ${theme.space[7]}px`,
  background:
    'radial-gradient(158.47% 62.42% at 0.71% 0%, rgba(255, 255, 255, 0.51) 0%, rgba(255, 255, 255, 0.00) 100%), linear-gradient(333deg, #004699 -7.78%, #0074FF 77.46%), url("/assets/images/myPath/myPathBackgroundBanner.svg")',
  backgroundSize: 'auto, auto, auto',
  backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
  backgroundPosition: '0 0, 0 0, right -40px top 20px',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 15,
    right: -50,
    width: '100%',
    height: '100%',
    backgroundImage: "url('/assets/images/myPath/myPathBackgroundBanner.svg')",
    backgroundSize: 'auto',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right -40px top 20px',
    opacity: 0.3,
    pointerEvents: 'none',
    zIndex: 0,
  },
  boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.10)',

  [`@media (max-width: ${theme._breakpoints[2]}px)`]: {
    height: 'fit-content',
    '&::after': {
      right: -20,
    },
  },
}));

const BackdropLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    98deg,
    var(--Primary-900, #002e66) -69.12%,
    rgba(0, 70, 153, 0.05) 151.88%
  );
  backdrop-filter: blur(0px);
  border-radius: 16px;
  z-index: 1;
`;

const Title = styled(Text)(({ theme }) => ({
  ...theme.textStyles.heading2,
  fontSize: 36,
  margin: 0,
  marginTop: 8,
  textShadow: '0px 2px 6px hsla(217, 99%, 40%, 0.6)',
}));

const GoToMypathButton = styled(ButtonOutlined)(({ theme }) => ({
  backgroundColor: theme.colors.white,
  boxShadow: '0px 12px 24px 0px hsla(0, 0%, 0%, 0.1)',
  padding: `${theme.space[3]}px ${theme.space[5]}px`,
  alignItems: 'center',
  justifyContent: 'space-between',
  display: 'flex',
  width: '100%',
  maxWidth: '200px',
  borderColor: 'transparent',
  gap: 8,
  '&:hover ,&:active ,&:focus': {
    backgroundColor: theme.colors.bsGrays.gray300,
    borderColor: 'transparent',
  },
}));

const BulletText = ({ title }) => {
  return (
    <Flex flexDirection={'row'} gridColumnGap={'8px'} alignItems={'center'}>
      <SvgIcon size={20} color={'backgroundYellow'} icon={SvgIcon.ICON_LIST.CHECK_CIRCLE} />
      <Text as={'p'} textStyle={'body1Medium'}>
        {title}
      </Text>
    </Flex>
  );
};

BulletText.propTypes = {
  title: PropTypes.string.isRequired,
};

const MyPathBanner = ({ goToMyPath }) => {
  const { t } = useTranslation('myPath');

  return (
    <BannerWrapper>
      <BackdropLayer />
      <Flex flexDirection={'column'} gridRowGap={'32px'} style={{ zIndex: 1 }}>
        <Flex flexDirection={'column'}>
          <Title>{t('BANNER.TITLE')}</Title>
          <Text as={'h5'} textStyle={'heading5'} fontWeight={400}>
            {t('BANNER.SUBTITLE')}
          </Text>
        </Flex>
        <Flex flexDirection={'column'} gridRowGap={'40px'}>
          <Flex flexDirection={'column'} gridRowGap={'12px'}>
            <BulletText title={t('BANNER.FEATURES.RECOMMEND_COURSES')} />
            <BulletText title={t('BANNER.FEATURES.CUSTOMIZE_SCHEDULE')} />
            <BulletText title={t('BANNER.FEATURES.CALCULATE_TIME')} />
          </Flex>
          <GoToMypathButton onClick={goToMyPath}>
            {t('BANNER.START_BUTTON')} <ArrowForwardRoundedIcon />
          </GoToMypathButton>
        </Flex>
      </Flex>
    </BannerWrapper>
  );
};

MyPathBanner.propTypes = {
  goToMyPath: PropTypes.func.isRequired,
};

export default MyPathBanner;
